<i18n lang="yaml">
ru:
  page_title: 'Регистрация'
  register_success: 'Ваш запрос на регистрацию успешно отправлен.'
  register_help_text: 'На адрес электронной почты, указанный в анкете, будет направлено сообщение от службы поддержки.'
  already_registered: 'Вы уже зарегистрированы на сайте.'
en:
  page_title: 'Registration'
  register_success: 'Your registration request has been sent.'
  register_help_text: 'Our support team will send you a letter to an Email you specified.'
  already_registered: 'You have been registered.'
</i18n>

<template>
  <section v-if="$auth.loggedIn" class="container" :class="theme_color">
    <h1 class="text_align-center">
      {{ $t('already_registered') }}
      <nuxt-link :to="localePath('/')">{{ $t('to_homepage') }}</nuxt-link>
    </h1>
  </section>
  <section v-else-if="!$noCartMode()" class="container register" :class="theme_color">
    <site-text-block type="register_distributor" class="register-text-block" />
    <distributor-form @registration-completed="registrationCompleted = true"/>
    <modal :visible="registrationCompleted" @close="redirectToMainPage">
      <template v-slot:header>
        <h3>{{ $t('register_success') }}</h3>
      </template>
      <template v-slot:body>
        {{ $t('register_help_text') }}
      </template>
      <template v-slot:footer>
        <button class="modal-default-button" @click="redirectToMainPage">{{ $t('continue') }}</button>
      </template>
    </modal>
  </section>
</template>

<script>
import DistributorForm from '@/components/forms/distributor-form';
import Modal from '@/components/modal';
import SiteTextBlock from '@/components/blocks/site-text-block';

export default {
  props: ['value', 'theme'],
  components: {
    DistributorForm,
    Modal,
    SiteTextBlock,
  },
  data() {
    return {
      registrationCompleted: false,
    }
  },
  computed: {
    theme_color() {
      return this.theme.value.theme
    }
  },
  methods: {
    redirectToMainPage() {
      this.$router.push({path: this.localePath('/')});
    },
  },
}
</script>
